import { education } from "../data";
import SectionHeading from "./SectionHeading";

const tones = ["pink", "blue"];

function About() {
  return (
    <section className="section container" id="education">
      <SectionHeading title="Education" />

      <div className="rows">
        {education.map((item, index) => (
          <article className={`row hover-${tones[index % tones.length]}`} key={item.title}>
            <span className="mono">{item.period}</span>
            <h3>{item.title}</h3>
            <span className="row-aside">{item.school}</span>
          </article>
        ))}
      </div>
    </section>
  );
}

export default About;
